import $ from "jquery";

$(function () {
	if ($('.stagger').length > 0) {
		$('.stagger').textEffect({
			effect: 'fade',
			effectSpeed: 50,
			completionSpeed: 1000
		});
	}
});
